<ac-form *ngIf="dialogConfig.ready"
         [formModel]="region"
         [formSchema]="schema"
         [isEdit]="isEdit"
         [validateAuxiliaryForm]="networkValidationsService.validateNetworkEntityName('region', additionalSettings.name,
         region.tenantId || additionalSettings.tenantId, 'tenantId')"
         formModelName="region">

    <div id="region-details-dialog-content">

        <div class="flexRowParentEqualChildren">
            <ac-input-container label="Region Name">
                <ac-textfield [(acModel)]="region.name" [attr.alternativeName]="'region.name'"
                              maxLength="30"
                              textFieldId="region-name"
                ></ac-textfield>
            </ac-input-container>

            <ac-input-container label="Description">
                <ac-textarea [(acModel)]="region.description"
                             [attr.alternativeName]="'region.description'"
                             textAreaId="region-description">
                </ac-textarea>
            </ac-input-container>
        </div>

        <network-tenant-region-selection [model]="region"
                                         [additionalSettings]="additionalSettings"
                                         (acTenantChanged)="region.tenantId = $event"
                                         [ngDisabledTenant]="isEdit"
                                         [showRegion]="false"
                                         [horizontalView]="true">
        </network-tenant-region-selection>

        <ac-input-container [ignoreRequired]="true" label="Subnet (CIDR Notation)">
            <ac-select [(acModel)]="region.autoDetectionAddressSpace.subnetMasks"
                       [addCustomTags]="true"
                       [attr.alternativeName]="'region.autoDetectionAddressSpace.subnetMasks'"
                       [bindLabel]="null" [bindValue]="null"
                       [multiple]="true"
                       selectionName="region.autoDetectionAddressSpace.subnetMasks">
            </ac-select>
        </ac-input-container>
    </div>
</ac-form>
